export const API_ENDPOINTS = {
  auth: {
    login: '/users/login',
    verifyOtp: '/users/verify-otp',
    forgotPassword: '/users/send-otp',
    resetPassword: '/users/reset-password',
    changePassword: '/users/change-password',
    forceChangePassword: '/users/force-change-password',
  },
  roles: {
    list: '/roles',
    create: '/roles',
  },
  workflowConfig: {
    list: '/workflows',
    create: '/workflows',
  },
  reminderSettings: {
    base: '/reminder-settings',
  },
  users: {
    list: '/users',
    create: '/users',
    bulkReassign: '/users/bulk-reassign',
  },
  claims: {
    list: '/claims',
  },
  tickets: {
    list: '/ticket',
    uploadClaimsFile: '/ticket/upload-claims-file',
    statusCounts: '/ticket/status-counts',
    assignments: '/ticket/assignments',
    trackerUsers: '/ticket/tracker/users',
    bulkAssignSelected: '/ticket/bulk-assign-selected',
  },
  approvals: {
    list: '/approvals',
    all: '/approvals/all',
    requesterNames: '/approvals/requester-names',
    bulkAction: '/approvals/bulk-action',
  },
  disputes: {
    list: '/disputes',
    mine: '/disputes/mine',
  },
  emailTemplates: {
    list: '/email-templates',
  },
  support: {
    list: '/support',
  },
  paymentPosting: {
    list: '/payment-posting',
  },
  departments: {
    uploadMedicalBillingFile: '/departments/medical-billing/upload-file',
    uploadMedicalCodingFile: '/departments/medical-coding/upload',
    uploadPriorAuthorizationFile: '/departments/prior-authorization/upload',
    uploadCredentialingFile: '/departments/credentialing/upload',
    uploadEligibilityBenefitsFile: '/departments/eligibility-benefits/upload',
    uploadAccountsReceivableFile: '/departments/accounts-receivable/upload',
    uploadDenialManagementFile: '/departments/denial-management/upload',
    uploadPatientBillingFile: '/departments/patient-billing/upload',
    uploadClientAssistanceFile: '/departments/client-assistance/upload',
    medicalBillingData: '/departments/medical-billing',
    medicalBillingFollowUp: '/departments/medical-billing',
    medicalCodingData: '/departments/medical-coding',
    priorAuthorizationData: '/departments/prior-authorization',
    credentialingData: '/departments/credentialing',
    eligibilityBenefitsData: '/departments/eligibility-benefits',
    accountsReceivableData: '/departments/accounts-receivable',
    accountsReceivableUploadBatches: '/departments/accounts-receivable/batches',
    accountsReceivableUploadBatch: '/departments/accounts-receivable/batch',
    denialManagementData: '/departments/denial-management',
    patientBillingData: '/departments/patient-billing',
    clientAssistanceData: '/departments/client-assistance',
  },
  modules: {
    list: '/modules',
  },
  auditLogs: {
    list: '/auditlogs',
  },
  dashboard: {
    version: '/dashboard/version',
    stats: '/dashboard/stats',
  },
  reports: {
    users: '/reports/users',
    claims: '/reports/claims',
    tickets: '/reports/tickets',
    auditLogs: '/reports/auditlogs',
  },
  tasks: {
    list: '/tasks',
    myTasks: '/tasks/my-tasks',
    summary: '/tasks/summary',
  },
  arAudit: {
    base: '/ar-audit',
    queue: '/ar-audit/queue',
    myAlerts: '/ar-audit/my-alerts',
  },
  clients: {
    list: '/clients',
    upsert: '/clients/upsert',
    uploadFile: '/clients/upload-file',
  },
  payerTfiDetails: {
    list: '/payer-tfi-details',
    upsert: '/payer-tfi-details/upsert',
    uploadFile: '/payer-tfi-details/upload-file',
  },
  arCategories: {
    list: '/ar-categories',
    upsert: '/ar-categories/upsert',
  },
  errorParameters: {
    list: '/error-parameters',
    upsert: '/error-parameters/upsert',
  },
  sessions: {
    base: '/sessions',
    create: '/sessions',
  },
  chat: {
    sessions: '/chat/sessions',
    session: (id: string) => `/chat/sessions/${id}`,
  },
} as const;
